export const types = [
  { id: 1, name: 'Expense' },
  { id: 2, name: 'Revenue' },
  { id: 3, name: 'Equity' },
  { id: 4, name: 'Liability' },
  { id: 5, name: 'Asset' },
  { id: 6, name: 'Bank' },
];
